<template>
  <ThemeECommerceContainerSection category-event-name="" event-name="">
    <div
      class="tw-flex tw-flex-col tw-gap-6 lg:tw-flex-row lg:tw-items-start lg:tw-gap-[164px]"
    >
      <div class="lg:tw-w-[480px] lg:tw-shrink-0">
        <div class="tw-flex tw-flex-col">
          <h2 class="tw-text-mb-title-1 lg:tw-text-dt-title-1">
            {{ modelValue.title }}
          </h2>
          <p
            class="tw-mt-0 tw-text-mb-body lg:tw-text-dt-body tw-text-dark-gray"
          >
            {{ modelValue.description }}
          </p>
        </div>
      </div>
      <ThemeECommerceDisplayClient
        class="lg:tw-w-[596px] lg:tw-shrink-0"
        :items="modelValue.content"
      />
    </div>
  </ThemeECommerceContainerSection>
</template>

<script lang="ts" setup>
defineProps({
  modelValue: {
    type: Object as PropType<HomeSection<ClientMeta[]>>,
    required: true,
  },
});
</script>
